var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.truncated)?_c('span',[_vm._v(_vm._s(_vm._f("truncate")(_vm.address,_vm.truncated, '...')))]):_c('span',[_vm._v(_vm._s(_vm.address))])
}
var staticRenderFns = []

export { render, staticRenderFns }